export const host =  JSON.parse(process.env.VUE_APP_USE_HOST.toLowerCase()) ? location.host : location.hostname;
export const siteUrl = process.env.VUE_APP_SITEURL;
export const spanishDefaultSite = '316sp';
export const siteDomainUrlSpanish =  process.env.VUE_APP_SITE_SPANISH_HOST_NAME;
export const repDashboardLogin =  process.env.VUE_APP_REP_LOGIN;
export const allowedDomains = [
  process.env.VUE_APP_SITE_HOST_NAME,
  process.env.VUE_APP_SITE_SPANISH_HOST_NAME
];